import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AnnouncementTicker = () => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        // We use _embed to make sure we can eventually pull images if needed
        const response = await axios.get('https://cms.nausurology.org/wp-json/wp/v2/posts?per_page=5&_embed');
        setAnnouncements(response.data);
      } catch (err) {
        console.error("Ticker Error:", err);
      }
    };
    fetchAnnouncements();
  }, []);

  if (announcements.length === 0) return null;

  const tickerKeyframes = `
    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
  `;

  return (
    <div style={{ backgroundColor: '#064e3b', color: 'white', padding: '10px 0', overflow: 'hidden', borderBottom: '1px solid #065f46' }}>
      <style>{tickerKeyframes}</style>
      <div style={{ display: 'flex', alignItems: 'center', maxWidth: '1280px', margin: '0 auto', padding: '0 16px' }}>
        
        <div style={{ backgroundColor: 'white', color: '#064e3b', fontSize: '10px', fontWeight: '900', padding: '2px 8px', borderRadius: '2px', marginRight: '20px', zIndex: 10, textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
          ALERTS
        </div>

        {/* This wrapper forces everything into one horizontal line */}
        <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', flex: 1 }}>
          <div style={{ display: 'inline-block', animation: 'marquee 25s linear infinite' }}>
            {announcements.map((item) => (
              <span key={item.id} style={{ marginRight: '60px', fontSize: '14px', fontWeight: '600' }}>
                <span style={{ color: '#4ade80', marginRight: '8px' }}>•</span>
                <span dangerouslySetInnerHTML={{ __html: item.title.rendered }} />
              </span>
            ))}
            {/* Duplicate for infinite loop */}
            {announcements.map((item) => (
              <span key={`dup-${item.id}`} style={{ marginRight: '60px', fontSize: '14px', fontWeight: '600' }}>
                <span style={{ color: '#4ade80', marginRight: '8px' }}>•</span>
                <span dangerouslySetInnerHTML={{ __html: item.title.rendered }} />
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementTicker;